import api from '@/libs/axios'
import { PaginatedList } from '../models/common/paginatedList'
import { TypeVisite } from '../models/options/typesVisite/typeVisite';
import { PrecisionNatureTypeVisite } from '../models/options/precisionsNatureTypeVisite/precisionNatureTypeVisite';

const resource = 'PrecisionsNatureTypeVisite'

export default class PrecisionsNatureTypeVisiteRessource {
  public async paginatedList(pagenumber?: number, pagesize?: number, search?: string) : Promise<PaginatedList<PrecisionNatureTypeVisite>> {
    const params = new URLSearchParams();
    if (pagenumber) params.append('PageNumber', pagenumber.toString()); 
    if (pagesize) params.append('PageSize', pagesize.toString()); 
    if (search && search.length) params.append('Search', search?.toString()); 

    const response = await api.get(`${resource}`, { params: params } )
    return response.data
  }
}
